import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-6 justify-center">
        <div className="h-5 w-16 bg-white/10 animate-pulse rounded" />
        <div className="h-5 w-16 bg-white/10 animate-pulse rounded" />
        <div className="h-5 w-16 bg-white/10 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap justify-center">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-white/80 hover:text-white transition-colors duration-200">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function FooterMenu() {
  return <MenuProvider menu_id="26">
      <FooterMenuConsumer />
    </MenuProvider>;
}
const socialLinks = [{
  id: 3,
  name: "LinkedIn",
  icon: Linkedin,
  href: "https://www.linkedin.com/"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[oklch(0.18_0.03_220)] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-4 flex flex-col items-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1399276/img/website_logo_white.png" alt="Aran Group" className="h-7 mb-6" />
            <p className="text-white/70 text-sm leading-relaxed">
              Strategic consulting services to move your business from idea to launch with expert guidance and operational excellence.
            </p>
          </div>

          <div className="md:col-span-4 flex flex-col items-start md:items-center">
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <FooterMenu />
          </div>

          <div className="md:col-span-4 flex flex-col items-start md:items-end">
            <h3 className="text-lg font-semibold mb-6">Connect With Us</h3>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={social.id} data-index={i} variant="ghost" size="icon" asChild className="bg-white/10 hover:bg-white/20 text-white rounded-md transition-all duration-200">
                    <Link to={social.href} newTab aria-label={social.name}>
                      <Icon className="size-5" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {currentYear} Aran Group. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="text-white/60 hover:text-white transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/60 hover:text-white transition-colors duration-200">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}